import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["iconBefore", "iconAfter", "small", "block", "className", "children"];
/* eslint-disable react/prop-types */
import * as React from 'react';
import clsx from 'clsx';
import Svg from '../Svg';
import { Base } from '../Base';
import ButtonBase from './ButtonBase';
var styles = {
  "root": "Button-root_1K7WZ",
  "icon": "Button-icon_1ticW",
  "sizeDefault": "Button-sizeDefault_39gwf",
  "sizeSmall": "Button-sizeSmall_2ic5Y",
  "iconBefore": "Button-iconBefore_zelCI",
  "iconAfter": "Button-iconAfter_Z3jA6",
  "block": "Button-block_2jTHc"
};
function Button(_ref, ref) {
  var _clsx;
  var iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    small = _ref.small,
    block = _ref.block,
    className = _ref.className,
    children = _ref.children,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var icon = iconBefore || iconAfter;
  var rootClasses = clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.sizeDefault, !small), _defineProperty(_clsx, styles.sizeSmall, small), _defineProperty(_clsx, styles.iconBefore, iconBefore), _defineProperty(_clsx, styles.iconAfter, iconAfter), _defineProperty(_clsx, styles.block, block), _clsx), className);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(ButtonBase, _extends({
      ref: ref,
      small: small,
      className: rootClasses
    }, extraProps), /*#__PURE__*/React.createElement(Base, {
      tagName: "span",
      flex: true,
      flexAlignItemsCenter: true,
      flexJustifyCenter: true,
      flexRowReverse: !!iconAfter
    }, icon && /*#__PURE__*/React.createElement(Svg, {
      name: icon,
      focusable: "false",
      className: styles.icon
    }), children))
  );
}
var Export = /*#__PURE__*/React.forwardRef(Button);
Export.displayName = 'Button';
export { Export as Button };